import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PortalTextBox from '../../portal/portalTextBox';
import PortalCheckBox from '../../portal/controls/checkbox';
import { TransparentButton, Button, ButtonType } from '@checkmarx/cx-ui';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import classNames from 'classnames';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'passwordPoliciesStore') @observer
export default class PasswordPolicySettings extends Component {
    policiesStore = this.props.passwordPoliciesStore;
    complexity = this.props.passwordPoliciesStore.complexity;
    t = this.props.translationsStore;

    componentDidMount() {
        this.policiesStore.getPasswordPoliciesForCurrentUser();
    }

    handleMinLengthChange = e => this.policiesStore.setPasswordLength(e.target.value);
    handleMinLengthOnBlur = e => this.policiesStore.validateMinPasswordLength();

    handleMinNoOfDigitChange = e => this.policiesStore.setPasswordMinNoOfDigits(e.target.value);
    handleMinNoOfDigitOnBlur = e => this.policiesStore.validateMinNoOfDigits();

    handleMinNoOfLowerChange = e => this.policiesStore.setPasswordMinNoOfLowers(e.target.value);
    handleMinNoOfLowerOnBlur = e => this.policiesStore.validateMinNoOfLowers();

    handleMinNoOfUpperChange = e => this.policiesStore.setPasswordMinNoOfUppers(e.target.value);
    handleMinNoOfUpperOnBlur = e => this.policiesStore.validateMinNoOfUppers();

    handleMinNoOfSpecialCharsChange = e => this.policiesStore.setPasswordMinNoOfSpecial(e.target.value);
    handleMinNoOfSpecialCharsOnBlur = e => this.policiesStore.validateMinNoOfSpecial();

    handlePasswordAgeChange = e => this.policiesStore.setPasswordAge(e.target.value);
    handlePasswordAgeOnBlur = e => this.policiesStore.validatePasswordAge();

    handlePasswordHistoryCountChange = e => this.policiesStore.setPasswordHistoryCount(e.target.value);
    handlePasswordHistoryCountOnBlur = e => this.policiesStore.validatePasswordHistoryCount();

    handleSubmitForm = (e) => {
        e.preventDefault();

        const isValid = this.policiesStore.validateForm();

        if (isValid === false) {
            return;
        }

        this.policiesStore.savePasswordPolicies().then((response) => {
            var level = ToastrLevelsEnum.SUCCESS;
            var message = this.props.translationsStore.translate('PASSWORD_COMPLEXITY_SUCCESS_MESSAGE');
            ToastrService.triggerToastr({ level, message });
        });
    }

    togglePasswordHistoryEnabled = () => {

        let currentEnabledPasswordHistory = this.complexity.passwordHistoryEnabled;
        this.policiesStore.setPasswordHistoryEnabled(!currentEnabledPasswordHistory);
    }

    toggleDisplayForgotPassword = () => {
        this.policiesStore.setForgotPasswordLinkSetting(!this.complexity.displayForgotPassword);
    }

    fieldWidth = '48%';


    render() {
        return (
            <form onSubmit={this.handleSubmitForm}>
                <div>
                    <div className="setting-sub-title">
                        {this.t.translate('PASSWORD_POLICIES_SUB_TITLE')}
                    </div>
                    <div className='ldap-server-settings-form-main-wrapper'>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-password-min-length'}
                                hintText={this.t.translate('PASSWORD_MIN_LENGTH')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_MIN_LENGTH')}
                                    required={true} />}
                                onChange={this.handleMinLengthChange}
                                onBlur={this.handleMinLengthOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minPwdLenValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.minPasswordLength}
                            />
                            <PortalTextBox
                                dataCy={'txt-password-min-noof-digits'}
                                hintText={this.t.translate('PASSWORD_MIN_DIGITS')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_MIN_DIGITS')}
                                    required={true} />}
                                onChange={this.handleMinNoOfDigitChange}
                                onBlur={this.handleMinNoOfDigitOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minDigitsValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.minNoOfDigits}
                            />
                        </div>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-password-min-noof-lowerchars'}
                                hintText={this.t.translate('PASSWORD_MIN_LOWER_CHARS')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_MIN_LOWER_CHARS')}
                                    required={true} />}
                                onChange={this.handleMinNoOfLowerChange}
                                onBlur={this.handleMinNoOfLowerOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minLowerCharsValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.minNoOfLowerChars}
                            />
                            <PortalTextBox
                                dataCy={'txt-password-min-noof-upperchars'}
                                hintText={this.t.translate('PASSWORD_MIN_UPPER_CHARS')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_MIN_UPPER_CHARS')}
                                    required={true} />}
                                onChange={this.handleMinNoOfUpperChange}
                                onBlur={this.handleMinNoOfUpperOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minUpperCharsValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.minNoOfUpperChars}
                            />
                        </div>
                        <div className='form-row start'>
                            <PortalTextBox
                                dataCy={'txt-password-min-noof-specialchars'}
                                hintText={this.t.translate('PASSWORD_MIN_SPECIAL_CHARS')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_MIN_SPECIAL_CHARS')}
                                    required={true} />}
                                onChange={this.handleMinNoOfSpecialCharsChange}
                                onBlur={this.handleMinNoOfSpecialCharsOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minSpecialCharsValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.minNoOfSpecialChars}
                            />
                            <PortalTextBox
                                dataCy={'txt-password-age'}
                                hintText={this.t.translate('PASSWORD_ENFORCE_AGE')}
                                floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_ENFORCE_AGE')}
                                    required={true} />}
                                onChange={this.handlePasswordAgeChange}
                                onBlur={this.handlePasswordAgeOnBlur}
                                width={this.fieldWidth}
                                errorText={this.policiesStore.minPwdAgeValidationMessage}
                                disabled={this.policiesStore.savingPolicy}
                                value={this.complexity.passwordAge}
                            />
                        </div>
                        <div className='form-row start' style={{ marginTop: '50px', marginBottom: '20px' }}>
                            <div style={{ width: '50%' }}>
                                <PortalCheckBox
                                    dataCy={'tgl-enforce-password-history'}
                                    dataKey={'enforcePasswordHistory'}
                                    checked={this.complexity.passwordHistoryEnabled}
                                    onCheck={this.togglePasswordHistoryEnabled}
                                    disabled={this.policiesStore.savingPolicy}
                                    label={this.t.translate('PASSWORD_ENFORCE_HISTORY')}
                                />
                            </div>
                            <div style={{ marginTop: '-52px', width: '50%', display: this.complexity.passwordHistoryEnabled ? 'block' : 'none' }}>
                                <PortalTextBox
                                    dataCy={'txt-password-history-count'}
                                    hintText={this.t.translate('PASSWORD_HISTORY_COUNT')}
                                    floatingLabelText={<TextfieldFloatingText title={this.t.translate('PASSWORD_HISTORY_COUNT')}
                                        required={true} />}
                                    onChange={this.handlePasswordHistoryCountChange}
                                    onBlur={this.handlePasswordHistoryCountOnBlur}
                                    width={'100%'}
                                    errorText={this.policiesStore.minPwdHistoryValidationMessage}
                                    disabled={this.policiesStore.savingPolicy}
                                    value={this.complexity.passwordsHistoryCount}
                                />
                            </div>
                        </div>
                        <div className='form-row start' style={{ marginTop: '50px', marginBottom: '20px' }}>
                            <div style={{ width: '50%' }}>
                                <PortalCheckBox
                                    dataCy={'tgl-display-forgot-password'}
                                    dataKey={'displayForgotPassword'}
                                    checked={this.complexity.displayForgotPassword}
                                    onCheck={this.toggleDisplayForgotPassword}
                                    disabled={this.policiesStore.savingPolicy}
                                    label={this.t.translate('DISPLAY_FORGOT_PASSWORD')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='general-settings-submit'>
                        <Button
                            dataCy='btn-password-settings-submit'
                            type='submit'
                            inProgress={this.policiesStore.savingPolicy}
                            text={this.props.translationsStore.translate('SAVE')} >
                        </Button>
                    </div>
                </div>
            </form>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/security/passwordPolicySettings/index.jsx